const { orgRoles, isPlacementCentre } = require('./org');

const subscriptionTypes = {
  SUBSTYPE_ORB: 'orb',
  SUBSTYPE_OIC: 'oic',
  SUBSTYPE_OPT: 'opt'
};

const orgSubscriptionType = orgData => {
  if (orgData.role === orgRoles.OIC_SCHOOL) {
    return subscriptionTypes.SUBSTYPE_OIC;
  }
  if (isPlacementCentre(orgData.orgConfig)) {
    return subscriptionTypes.SUBSTYPE_OPT;
  }
  return subscriptionTypes.SUBSTYPE_ORB;
};

const subIsCurriculumType = subType => subType === subscriptionTypes.SUBSTYPE_OIC;
const subIsPlacementType = subType => subType === subscriptionTypes.SUBSTYPE_OPT;

module.exports = {
  subscriptionTypes,
  orgSubscriptionType,
  subIsCurriculumType,
  subIsPlacementType
};
